/* Après l’étape 5 — RJ-05 (Bible §23/§25).
   The rule is explicit at publish; evergreen is the locked default (#12).
   « La suite continue à chaque visite. » */
import { useState } from 'react'
import { ListRow, Note } from '@/ui'
import { Retour } from './parts'

const OPTIONS = [
  { id: 'evergreen', label: 'Expérience permanente', meta: 'Une expérience stable à chaque retour — recommandé' },
  { id: 'loop', label: 'Reboucler les étapes 2–5', meta: 'Le parcours recommence sans l’accueil' },
  { id: 'restart', label: 'Redémarrer après longue absence', meta: 'Repart de l’étape 1 après 12 mois d’inactivité' },
  { id: 'wallet', label: 'Portefeuille uniquement', meta: 'Plus de nouvelles expériences — Mes cadeaux reste' },
]

export default function Apres5() {
  const [choix, setChoix] = useState('evergreen')

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 720 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Après l’étape 5</h2>

      <section>
        {OPTIONS.map(o => (
          <ListRow key={o.id} title={o.label} meta={o.meta}
            end={<input type="radio" name="apres5" className="chk" style={{ borderRadius: '50%' }}
              checked={choix === o.id} onChange={() => setChoix(o.id)}
              aria-label={o.label} />} />
        ))}
      </section>

      <Note tone="ok">La suite continue à chaque visite.</Note>
    </div>
  )
}
